import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSyncStatuses as GetSyncStatusesQuery,
    TaskSync as TaskSyncFragment,
} from 'nutshell-graphql-types';

import GET_SYNC_STATUSES_QUERY from '../integrations/graphql/queries/get-sync-statuses.graphql';

class TaskSyncQuery extends Query<GetSyncStatusesQuery, Record<any, any>> {}

type Props = {
    children: (arg1: {
        taskSync: TaskSyncFragment | null | undefined;
        refetch: () => Promise<any>;
        isLoading: boolean;
        hasO365CalendarSync: boolean;
        errorMessage: string | null | undefined;
    }) => React.ReactElement;
};

export const GetTaskSync = (props: Props) => (
    <TaskSyncQuery query={GET_SYNC_STATUSES_QUERY}>
        {({data, loading, refetch, error}) => {
            const taskSyncData = data || {};
            // @ts-expect-error
            const loggedInUser = taskSyncData && taskSyncData.loggedInUser;
            const taskSync = (loggedInUser && loggedInUser.taskSync) || null;
            // @ts-expect-error
            const errorMessage = safelyGetGraphQLErrorMessage(error);
            // We need to determine if the user has O365 calendar sync enabled,
            // because then we can't connect to other services. Hopefully this
            // will go away soon when we implement O365 task sync
            const hasO365CalendarSync =
                (loggedInUser &&
                    loggedInUser.calendarSync &&
                    loggedInUser.calendarSync.isEnabled &&
                    loggedInUser.calendarSync.externalService === 'OFFICE365') ||
                false;

            return props.children({
                isLoading: loading,
                refetch,
                taskSync,
                hasO365CalendarSync,
                errorMessage,
            });
        }}
    </TaskSyncQuery>
);
